import { data } from 'jquery';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MediaService } from 'src/app/new-media/common/media.service';
import { SiteService } from 'src/app/new-sites-management/common/services/site.service';
// import { ManageMediaComponent } from '../manage-media.component';
import {MatDialogRef as MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-meta',
  templateUrl: './meta.component.html',
  styleUrls: ['./meta.component.css']
})
export class MetaComponent implements OnInit {
  @Input() data;

  public metaForm = new FormGroup({
    id: new FormControl(0, Validators.required),
    cultureId: new FormControl("", Validators.required),
    title: new FormControl("", Validators.required),
    altText: new FormControl(""),
    description: new FormControl(""),
    properties: new FormControl(""),
    order: new FormControl('', [Validators.min(0) ]),

  });
x
  constructor(
    public siteService: SiteService,
    private mdeiaService: MediaService,
    private snotifyService: ToastrService,
    private dialogRef: MatDialogRef<any>) {
this.x=this.data

     }

  ngOnInit() {
    this.siteService.usedSiteCulture$.subscribe((res:any) => {
      this._cultureId.setValue(res[0].id);
      this._id.setValue(this.data.id);
      this.setValues();
    });
  }

  setValues() {
    this.mdeiaService.getMediaDetailsbyCultureId(this._cultureId.value, this.data.id)
      .subscribe((res: any) => {
        let mediaData = {
          id: this.data.id,
          cultureId: res.cultureId || this._cultureId.value,
          title: res.title,
          altText: res.altText,
          order:res.order,
          description: res.description,
          properties: '',
        }
        this.metaForm.patchValue(mediaData)
      });
  }

  public submit() {
    this.mdeiaService.saveMeta(this.metaForm.value).subscribe(
      (res: any) => {
        this.openNotifySuccess(res);
        this.mdeiaService
          .searchMediaAndFolders(this.mdeiaService.folder.parentId ? this.mdeiaService.folder.parentId : 0)
          .subscribe();
        this.close();
      } 
    );
  }

  close() {
    this.dialogRef.close();
  }

  public openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2500,
      progressBar: true,
      tapToDismiss: true
    });
  }
 
  get _id() { return this.metaForm.get('id') }
  get _cultureId() { return this.metaForm.get('cultureId') }
  get _title() { return this.metaForm.get('title') }
  get _altText() { return this.metaForm.get('altText') }
  get _description() { return this.metaForm.get('description') }
  get _order(){ return this.metaForm.get('order')}

}
